import { get, orderBy } from 'lodash';
import { action, computed, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';

class PlacementTestReportTestDialogService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
      placementTestId: null,
      data: {},
      errorsPerAbility: computed(() =>
        get(this.data, 'answeredItems', [])
          .filter((answeredItem) => !answeredItem.correct)
          .reduce(
            (acc, answeredItem) => {
              if (get(answeredItem.item, 'type.key') === 'SINGLE_CHOICE_TEXT') {
                return { ...acc, readingErrors: acc.readingErrors + 1, listeningErrors: acc.listeningErrors + 1 };
              }
              if (
                ['GAP_FILL', 'GAP_FILL_MULTIPLE', 'GAP_FILL_SELECT', 'UNSCRAMBLE_DRAG_AND_DROP'].some(
                  (type) => type === get(answeredItem.item, 'type.key')
                )
              ) {
                return { ...acc, readingErrors: acc.readingErrors + 1 };
              }
              if (
                ['SINGLE_CHOICE_AUDIO', 'SINGLE_CHOICE_IMAGE'].some(
                  (type) => type === get(answeredItem.item, 'type.key')
                )
              ) {
                return { ...acc, listeningErrors: acc.listeningErrors + 1 };
              }
              return acc;
            },
            { readingErrors: 0, listeningErrors: 0 }
          )
      ),
      errorsPerLevel: computed(() => {
        const data = get(this.data, 'answeredItems', [])
          .filter((answeredItem) => !answeredItem.correct)
          .reduce((acc, answeredItem) => {
            if (!get(answeredItem.grammarPlacementTestLevel, 'placementTestLevel', false)) {
              return acc;
            }

            const currentLevel = acc.find(
              (level) => level.level === get(answeredItem, 'grammarPlacementTestLevel.placementTestLevel.course.name')
            );

            if (currentLevel) {
              return [
                ...acc.filter((level) => level.level !== currentLevel.level),
                {
                  ...currentLevel,
                  errors: currentLevel.errors + 1,
                },
              ];
            } else {
              return [
                ...acc,
                { level: get(answeredItem, 'grammarPlacementTestLevel.placementTestLevel.course.name'), errors: 1 },
              ];
            }
          }, []);
        return orderBy(data, ['errors'], ['desc']);
      }),
      errorsPerGrammar: computed(() => {
        const data = get(this.data, 'answeredItems', [])
          .filter((answeredItem) => !answeredItem.correct)
          .reduce((acc, answeredItem) => {
            const currentGrammar = acc.find((grammar) => grammar.grammar === get(answeredItem, 'item.grammar.name'));

            if (currentGrammar) {
              return [
                ...acc.filter((grammar) => grammar.grammar !== currentGrammar.grammar),
                {
                  ...currentGrammar,
                  total: currentGrammar.total + 1,
                },
              ];
            } else {
              return [...acc, { grammar: get(answeredItem, 'item.grammar.name'), total: 1 }];
            }
          }, []);
        return orderBy(data, ['total'], ['desc']);
      }),
    });
  }

  handleOpenDialog = action((placementTestId) => {
    this.isOpen = true;
    this.placementTestId = placementTestId;
    this.load();
  });

  handleCloseDialog = action(() => {
    this.isOpen = false;
    this.placementTestId = null;
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: `/placement-test-report/${this.placementTestId}/details`,
      })
      .then(() => {
        if (this.fetch.data) {
          this.data = {
            ...this.fetch.data,
            answeredItems: this.fetch.data.answeredItems.reduce((acc, answeredItem) => {
              if (get(answeredItem, 'item.id')) {
                return [...acc, answeredItem];
              }
              return [...acc];
            }, []),
          };
        } else {
          this.data = {};
        }
      });
  });
}

const placementTestReportTestDialogService = new PlacementTestReportTestDialogService();
export default placementTestReportTestDialogService;
